import indexMixin from "../mixins/index";
export default {
  name: 'res-button',
  mixins: [indexMixin],
  props: {
    btnsOptions: {
      type: Array,
      default: () => []
    },
    isBtnGroup: {
      type: Boolean,
      default: false
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    buttonName: {
      type: String,
      default: '默认按钮'
    },
    labelKey: {
      type: String,
      default: "label"
    },
    iconKey: {
      type: String,
      default: "icon"
    }
  },

  data() {
    return {};
  },

  methods: {
    /**
      * 单击单个按钮事件触发，参数为点击的元素和索引
    */
    handleClick(item, index, $event) {
      this.$emit('click', item, index, $event);
    }

  }
};